import {
  Box,
  Button,
  DialogProps,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  TypographyPropsVariantOverrides,
} from '@mui/material'
import Label from 'components/Label'
import React, { Fragment, useState } from 'react'
import { OverridableStringUnion } from '@mui/types'
import { Variant } from '@mui/material/styles/createTypography'
import { DocumentType } from 'types/document.type'
import { formatDocument } from 'utils/text.util'
import VisibilityIcon from '@mui/icons-material/Visibility'
import DialogTitle from '@mui/material/DialogTitle'
import CloseIcon from '@mui/icons-material/Close'
import DialogContent from '@mui/material/DialogContent'
import { DataGridCustom } from 'pages/CreateCreas/components/TableData/style'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import { renderFileContent } from 'utils/base64.utils'

type FieldProps = {
  label: string
  values?: DocumentType[] | null
  direction: 'column' | 'row'
  variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>
}

export const FieldDocuments: React.FC<FieldProps> = ({ label, values, direction, variant }) => {
  const directionProps = direction === 'row' ? { spacing: 1 } : null

  return (
    <Stack direction={direction} {...directionProps}>
      <Label text={label} bold v={variant || 'body1'} />
      {values &&
        values.map((item, index) => (
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'} key={item.id} gap={2}>
            <Label key={index} text={formatDocument(item)} v={variant || 'body1'} />
            <DocumentModal data={item} />
          </Box>
        ))}
    </Stack>
  )
}

type DocumentModalProps = {
  data: DocumentType
}

const DocumentModal = ({ data }: DocumentModalProps) => {
  const [fullWidth] = useState(true)
  const [maxWidth] = useState<DialogProps['maxWidth']>('lg')

  const [open, setOpen] = useState<boolean>(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <Fragment>
      {data.arquivoBase64 && (
        <Fragment>
          <Tooltip title={'Visualizar documento.'}>
            <IconButton size={'small'} onClick={handleOpen}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Dialog open={open} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth}>
            <DialogTitle>
              <Typography variant={'h6'} color={'primary.main'}>
                Visualizar documento
              </Typography>
            </DialogTitle>
            <IconButton
              aria-label='close'
              onClick={handleClose}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <DialogContent>
              {renderFileContent(data.arquivoNome, data.arquivoBase64, data.arquivoTipo)}
            </DialogContent>
          </Dialog>
        </Fragment>
      )}
    </Fragment>
  )
}
